export const en = {
    clients: 'Clients',
    currency: 'Currency',
    name: 'Name',
    period: 'Period',
    'price-context': 'CPM',
    'shows-max': 'Impressions, max',
    'shows-min': 'Impressions, min',
    status: 'Status',
    targetings: 'Targetings'
};
